"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageClient = void 0;
const tslib_1 = require("tslib");
const crud_client_1 = require("./crud.client");
class PageClient extends crud_client_1.CrudClient {
    constructor() {
        super(...arguments);
        this.entityPath = 'page-group';
    }
    createMappingAndPageGroup(projectId, mappingData, pageGroupData) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/page-group/create`;
            const response = yield this.httpPost(url, { pageGroupData, mappingData });
            return response.payload;
        });
    }
    createPageGroup(projectId, mappingId, pageGroupData, conflictsPageGroupsIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/mappings/${mappingId}/page-group/create`;
            const response = yield this.httpPost(url, { pageGroupData, conflictsPageGroupsIds });
            return response.payload;
        });
    }
    includeFiltersInPageGroup(projectId, mappingId, includeData, conflictsPageGroupsIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/mappings/${mappingId}/page-group/include`;
            const response = yield this.httpPut(url, { includeData, conflictsPageGroupsIds });
            return response.payload;
        });
    }
    refinePageGroupFilters(projectId, mappingId, refineData, conflictsPageGroupsIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/mappings/${mappingId}/page-group/refine`;
            const response = yield this.httpPut(url, { refineData, conflictsPageGroupsIds });
            return response.payload;
        });
    }
    createMappingAndSplitPageGroup(projectId, mappingData, splitData) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/page-group/split`;
            const response = yield this.httpPut(url, { mappingData, splitData });
            return response.payload;
        });
    }
    splitPageGroup(projectId, mappingId, splitData) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/mappings/${mappingId}/page-group/split`;
            const response = yield this.httpPut(url, { splitData });
            return response.payload;
        });
    }
    updatePageGroup(projectId, pageId, page) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/pages/${pageId}`;
            const response = yield this.httpPut(url, page);
            return response.payload;
        });
    }
    deleteManyPageGroupsWithLinkedItems(projectId, mappingId, pageGroupIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/mappings/${mappingId}/page-groups?${this.getQueryString({ pageGroupIds })}`;
            const response = yield this.httpDelete(url);
            return response.payload;
        });
    }
}
exports.PageClient = PageClient;
//# sourceMappingURL=page.client.js.map